import { AktionBeendet } from "@/components/AktionBeendet";

// Didacta-Aktion (kostenlose Mitgliedschaft bis 31.03.2026): beendet, Anmeldung stillgelegt (Frage 257, 13.10.2026).
// Die alte Seite mit Formular steht in der Git-Historie.
const Didacta = () => (
  <AktionBeendet
    titel="Didacta-Aktion"
    text="Die kostenlose Mitgliedschaft zur Didacta lief bis zum 31. März 2026. Du kannst dich weiter kostenlos registrieren und MusiKonzept kennenlernen."
  />
);

export default Didacta;
